export const customInjectedScript = `
`;
